import * as Icons from '@mui/icons-material';

const Icon = ({ iconName }) => {
    if (!(iconName in Icons)) {
        return <div></div>;
    }
    const IconComponent = Icons[iconName];
    return (
        <IconComponent />
    )
};

export default Icon;
